// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 类型
  getPileTypes(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/pileType/getPileTypes', params)
  },
  saveOrUpdatePileType(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/pileType/saveOrUpdatePileType', params)
  },
  deletePileType(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/pileType/deletePileType', params)
  },
  getPileTypeEnum(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestGet(apiPre + service.res + '/res/pileType/getPileTypeEnum', params)
  },
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/typeApi.js